import { useState } from 'react';
import CustomButton from '../../reusable/CustomButton';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { configureDemographicCategories } from '../../../services/eoaConfigServices';
import useUserDetails from '../../hooks/useUserDetails';
import useErrorModal from '../../hooks/useErrorModal';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { DemographicCategory } from '../../../interfaces/EOAInterface';
import DemographicCategoryConfig from './DemographicCategoryConfig';

import './DemographicSettings.css';

const defaultGenders = [
  { district_name: 'Male', aliases: [] },
  { district_name: 'Female', aliases: [] },
];
const defaultLiItems = [
  { district_name: 'Low Income', aliases: [] },
  { district_name: 'Not Low-Income', aliases: [] },
];
const defaultEllItems = [
  { district_name: 'Native / Fluent', aliases: [] },
  { district_name: 'English Language Learner', aliases: [] },
];
const defaultSwdItems = [
  { district_name: 'With Disability', aliases: [] },
  { district_name: 'Without Disability', aliases: [] },
];

function DemographicSettings() {
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();
  const { handleOpen: handleOpenErrorModal } = useErrorModal();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();

  const [gender, setGender] = useState<DemographicCategory>({
    district_name: 'GENDER',
    demographic_values: [...defaultGenders],
  });
  const [race, setRace] = useState<DemographicCategory>({ district_name: 'RACE', demographic_values: [] });
  const [ell, setEll] = useState<DemographicCategory>({
    district_name: 'ELL',
    demographic_values: [...defaultEllItems],
  });
  const [li, setLi] = useState<DemographicCategory>({ district_name: 'LI', demographic_values: [...defaultLiItems] });
  const [swd, setSwd] = useState<DemographicCategory>({
    district_name: 'SWD',
    demographic_values: [...defaultSwdItems],
  });

  const saveButtonDisabled = !race.demographic_values.length || race.demographic_values.length > 10;

  const handleSaveDemographicSettings = async () => {
    const demographicSettingsData = {
      GENDER: gender,
      RACE: race,
      LI: li,
      ELL: ell,
      SWD: swd,
    };

    if (userDetails) {
      try {
        await configureDemographicCategories(userDetails.eoaId, userDetails.access_token, demographicSettingsData);
        navigate('/eoa');
      } catch (error) {
        console.error(error);
        handleOpenErrorModal('Error occured while saving demographic settings!', error as AxiosError);
      }
    }
  };

  return (
    <div className="demographic-settings-data-fields">
      {/* GENDER */}
      <DemographicCategoryConfig
        category={gender}
        setCategory={setGender}
        categoryName="Gender"
        defaultCategoryValues={defaultGenders}
      />
      {/* RACE/ETH */}
      <DemographicCategoryConfig category={race} setCategory={setRace} categoryName="Race" />
      {/* SOCIO ECONOMIC/LI */}
      <DemographicCategoryConfig
        category={li}
        setCategory={setLi}
        categoryName="Socio Economics"
        defaultCategoryValues={defaultLiItems}
        newValueOption={false}
      />
      {/* ELL */}
      <DemographicCategoryConfig
        category={ell}
        setCategory={setEll}
        categoryName="ELL Status"
        defaultCategoryValues={defaultEllItems}
      />
      {/* DISABILITY/SWD */}
      <DemographicCategoryConfig
        category={swd}
        setCategory={setSwd}
        categoryName="Disability Status"
        defaultCategoryValues={defaultSwdItems}
        newValueOption={false}
      />
      <CustomButton
        variant="primary"
        size="medium"
        buttonText="Save Demographic Settings"
        buttonAction={handleSaveDemographicSettings}
        disabled={saveButtonDisabled}
      />
    </div>
  );
}

export default DemographicSettings;
